module.exports = __webpack_public_path__ + "media/images/badges/akt/milestone-1-Inactive-AKT-8027ef8ad5da07dedf1a066e00fb5770.png";